export const TAXONOMY_DEFAULT_ORDER_BY: TaxonomySortBy = 'createdAt-desc'
export const TAXONOMY_SORT_BY = ['createdAt', 'name', 'type'] as const
export type TaxonomySortBy =
  `${(typeof TAXONOMY_SORT_BY)[number]}-${'asc' | 'desc'}`
export const TAXONOMIES_DEFAULT_SEARCH = {
  name: '',
  sortBy: TAXONOMY_DEFAULT_ORDER_BY,
  createdAt: null,
} as const
